<template>
	<div class="home">
		<van-nav-bar
			left-arrow
			fixed
			:title="'ID:'+staff.account"
		  	@click-left="$router.go(-1)">
			<!-- <van-icon name="./static/img/Trash.png" slot="right" @click="delStaff()" style="font-size: 24px;"/> -->
		</van-nav-bar>
		<van-cell-group>
			<!-- <van-cell v-if="chef=='1'||chef=='0'" class="bigCell" :title="$t('ShopSet.autoPrint')" size="large">
				<van-switch :value="chef=='1'" @input="changeChef" active-color="#2f75f7" inactive-color="#ee0a24" />
			</van-cell> -->
		  	<van-image
		  		class="noInput"
			  	width="100%"
			  	height="150"
			  	fit="contain"
			  	:src="staff.qrcode+'?time='+clickTime"
			/>
		  	<van-field
		  		class="noInput"
		  		readonly
			  	:label="$t('CookInfo.loginLink')"
			  	:value="staff.link"
			  	type="textarea"
			  	autosize
		  	/>
			<div class="wrapper">
				<span class="textWrapper">{{$t('EditBook.copy')}}:</span>
				<div class="refresh" @click="copy()">{{$t('EditBook.copyBtn')}}</div>
			</div>
			<div class="wrapper">
				<span class="textWrapper">{{$t('EditBook.refresh')}}:</span>
				<div class="refresh" @click="refreshQRcode()">{{$t('EditBook.refreshBtn')}}</div>
			</div>
			<!-- <div class="refresh" @click="copy()">{{$t('CookInfo.copy')}}</div> -->
			<!-- <div class="refresh" @click="refreshQRcode()">{{$t('CookInfo.refresh')}}</div> -->
		</van-cell-group>
	</div>
</template>

<script>
export default {
    data () {
      	return {
      		staff:{},
  			clickTime:0,
  			checked:false,
  			chef:'',
      	}
    },
    mounted:function(){
    	this.getShop();
    	this.getStaff();
    },
    methods:{
    	getShop(){
    		this.$axios({
                method: 'get',
                headers: {
                    "Authorization": 'Bearer '+sessionStorage.token,
                },
                url: this.$build+'/api/store/'+sessionStorage.actShopId+'/show',
            }).then(res => {
            	console.log(res);
            	if(res.data.status==200){
					this.chef=res.data.data.chef;
            	}else{
            		for (var item in res.data.error) {
            			this.$toast({
		            		type:'fail',
		            		message:res.data.error[item],
		            	});
            		}
            	}
            }).catch(err => {
            	this.$toast({
            		type:'fail',
            		message:this.$t('EditShop.message'),
        		});
            });
    	},
    	changeChef(){
    		var val=this.chef=='1'?'0':'1';
    		this.$axios({
                method: 'PATCH',
                headers: {
                    "Authorization": 'Bearer '+sessionStorage.token,
                },
                url: this.$build+'/api/store/'+sessionStorage.actShopId+'/update',
                data:{
                	chef:val,
                },
            }).then(res => {
            	 console.log(res);
            	if(res.data.status==200){
                	this.$toast({
	            		type:'success',
	            		message:res.data.message,
	            	});
	            	this.chef=val;
            	}else{
            		this.$toast.allowMultiple();
            		for (var item in res.data.error) {
            			this.$toast({
		            		type:'fail',
		            		message:res.data.error[item],
		            	});
            		}
            	}
            }).catch(err => {
            	this.$toast({
            		type:'fail',
            		message:this.$t('EditShop.message'),
        		});
            });
    	},
		getStaff(){
    		this.$axios({
                method: 'get',
                headers: {
                    "Authorization": 'Bearer '+sessionStorage.token,
                },
                url: this.$build+'/api/store/'+sessionStorage.actShopId+'/chef',
            }).then(res => {
            	console.log(res);
            	if(res.data.status==200){
                	this.staff=res.data.data;
            	}else{
            		for (var item in res.data.error) {
            			this.$toast({
		            		type:'fail',
		            		message:res.data.error[item],
		            	});
            		}
            	}
            }).catch(err => {
            	this.$toast({
            		type:'fail',
            		message:this.$t('CookInfo.message'),
        		});
            });
		},
		refreshQRcode(){//刷新二维码及链接
			this.$axios({
                method: 'get',
                headers: {
                    "Authorization": 'Bearer '+sessionStorage.token,
                },
                url: this.$build+'/api/user/'+this.staff.id+'/refresh',
            }).then(res => {
            	console.log(res);
            	if(res.data.status==200){
	            	this.clickTime=this.clickTime+1;
                	this.$toast({
	            		type:'success',
	            		message:res.data.message,
	            	});
	            	this.getStaff();
            	}else{
            		for (var item in res.data.error) {
            			this.$toast({
		            		type:'fail',
		            		message:res.data.error[item],
		            	});
            		}
            	}
            }).catch(err => {
            	this.$toast({
            		type:'fail',
            		message:this.$t('CookInfo.message'),
        		});
            });
		},
		copy() {//复制当剪切板
		    let transfer = document.createElement('input');
		    document.body.appendChild(transfer);
		    transfer.value = this.staff.link;  // 这里表示想要复制的内容
		    transfer.focus();
		    transfer.select();
		    if (document.execCommand('copy')) {
		        document.execCommand('copy');
		    }
		    transfer.blur();
		    document.body.removeChild(transfer);
		    this.$toast({
		    	duration:800,
        		type:'success',
        		message:this.$t('CookInfo.copyScuess'),
    		});  
		}
    },
}
</script>
<style scoped>
	/deep/ .van-nav-bar .van-icon{
		font-size: 24px;
		color: #fff;
	}
	/deep/ .van-field__left-icon .van-icon{
		font-size: 20px;
	}
	/deep/ .van-cell .van-icon{
		font-size: 20px;
	}
	.home{
		width: 100%;
		/*height: 100vh;*/
		background: #F3F5F7;
		padding-bottom: 60px;
	}
	.inputAr .van-field__body input{
		text-align: right;
	}
	/deep/ .van-picker__cancel,/deep/ .van-picker__confirm{
		color:#FFC914;
	}
	/deep/ .van-cell-group{
		background: #f3f5f7;
	}
	.selSex{
        width: 50px;
        float: right;
    }
    .bottom{
		position: fixed;
		bottom: 0;
		width: 100%;
		height: 60px;
		background: #fff;
	}
	.link{
		word-wrap: break-word;
		padding:20px;
	}
	.qrcodeImg{
		text-align: center;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 20px;
	}
	.noInput{
		margin-top: 10px;
		background-color: #f3f5f7;
	}
	.refresh{
		width: 120px;
		height: 30px;
		line-height: 30px;
		text-align: center;
		border-radius: 15px;
		color: #fff;
		background: #2f75f7;
		margin: 10px auto;
		margin-right: 10px;
	}
	.bigCell{
		line-height: 38px;
	}
	.wrapper{
		display: flex;
		padding: 0 16px;
	}
	.textWrapper{
		line-height: 50px;
	}
</style>




// WEBPACK FOOTER //
// src/Staff/CookInfo.vue